import { FC, useMemo } from 'react';

import DataTable from 'components/tables/data-table';
import { useAuth } from 'contexts';
import unitDataColumns, { defaultUnitColumns } from 'pages/units/grid/unit-columns';
import { useParams } from 'react-router-dom';
import { downloadUngroupedCsv, fetchActiveUnitsUngrouped } from 'services';
import { ActiveUnit } from 'types';

const TransactionUnits: FC<{ units?: ActiveUnit[] }> = ({ units }) => {
  const { transactionId } = useParams();
  const { userProfile } = useAuth();

  const fetchData = useMemo(() => fetchActiveUnitsUngrouped({ transactionId }), [transactionId]);

  const initialColumns = useMemo(() => {
    return userProfile.columnPreferences.filter(cp => cp.table === 'UNIT_UNSTACKED').length > 0
      ? userProfile.columnPreferences
          .filter(cp => cp.table === 'UNIT_UNSTACKED')
          .map(({ column, width }) => {
            return { field: column, width };
          })
      : defaultUnitColumns.map(c => {
          return { field: c, width: 80 };
        });
  }, [userProfile.columnPreferences]);

  return !transactionId ? null : (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>EQUIPMENT DETAILS</h4>
      </div>
      <div className="card-body">
        {!units ? (
          <DataTable
            columns={unitDataColumns}
            fetchData={fetchData}
            fetchCsv={downloadUngroupedCsv({ transactionId })}
            initialPage={{ sortField: 'createdDate', sortDirection: 'desc' }}
            initialColumns={initialColumns}
          />
        ) : (
          <DataTable
            columns={unitDataColumns}
            fetchData={async () => units}
            initialPage={{ sortField: 'createdDate', sortDirection: 'desc' }}
            initialColumns={initialColumns}
            clientSidePagination
          />
        )}
      </div>
    </div>
  );
};

export default TransactionUnits;
